/* eslint-disable no-use-before-define */
import React from 'react'
import toSearchParams from './to-search-params'
import { ajax, arrayFrom, cleanObject, showModal }from '../../twd'

export default ({errors, values}) => {
    const hasError = Object.keys(errors).length>0

    return <button
        data-name="advanced-screener-save-search-button"
        className="btn btn-lg btn-primary-outline btn-block"
        type="button"
        disabled={hasError}
        onClick={async (e) => {
            await saveSearch({values, source:e.target})
        }}
        >Save search</button>
}

export const saveSearch = async ({values, source}) => {

    let qId = values.savedQueryId
    let q = await getSavedQuery(qId) || {}

    let sp = Object.assign({
        searchType:'offers',
        savedQueryId: qId,
    }, toSearchParams(values))

    let p = cleanObject({
        id: qId,
        description: q.description || '',
        notes: q.notes,
        isCopy: 'N',
        formText: JSON.stringify(sp),
        source,
    })

    showModal({view:'save-search', params:p})
}


const getSavedQuery = async (qId) => {
    if (!qId) return
    try {
        let {data} = ajax({
            url: '/esb/portfolio/savedQuerySearchById/' + qId,
            method: 'GET'
        })

        return arrayFrom(await data)[0] || {}
    } catch(e) {
        return
    }
}

